define("shared/components/shared/post/secondary/activity/action", ["exports", "@ember/component", "@ember/string", "@glimmer/component", "later/models/post-activity", "@ember/template-factory"], function (_exports, _component, _string, _component2, _postActivity, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/string",0,"@glimmer/component",0,"later/models/post-activity",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <li class={{concat-classes "cAP--list__item qa--activity_modal_commentItem" (if @action.isNew "is--new")}}>
    <div class="cAP--userInitial">
      <span>{{this.usernameInitial}}</span>
    </div>
    <div class="cAP--comment">
      <div class="cAP--comment__header u--ellipsis">
        <span class="cAP--comment__userName u--ellipsis">{{@action.username}}</span>
        <span class="cAP--comment__timestamp">{{@action.timestamp}}</span>
      </div>
      <div>
        {{#if this.isApprovedAction}}
          <span class="cAP--label--success">
            {{t "shared_words.approved"}}
          </span>
        {{else if this.isSubmittedAction}}
          <span class="cAP--label--warning">
            {{t "approval.secondary-modal.body.submitted_for_review"}}
          </span>
        {{/if}}
      </div>
    </div>
  </li>
  */
  {
    "id": "F0ZVPdti",
    "block": "[[[10,\"li\"],[15,0,[28,[37,0],[\"cAP--list__item qa--activity_modal_commentItem\",[52,[30,1,[\"isNew\"]],\"is--new\"]],null]],[12],[1,\"\\n  \"],[10,0],[14,0,\"cAP--userInitial\"],[12],[1,\"\\n    \"],[10,1],[12],[1,[30,0,[\"usernameInitial\"]]],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"cAP--comment\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"cAP--comment__header u--ellipsis\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"cAP--comment__userName u--ellipsis\"],[12],[1,[30,1,[\"username\"]]],[13],[1,\"\\n      \"],[10,1],[14,0,\"cAP--comment__timestamp\"],[12],[1,[30,1,[\"timestamp\"]]],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[12],[1,\"\\n\"],[41,[30,0,[\"isApprovedAction\"]],[[[1,\"        \"],[10,1],[14,0,\"cAP--label--success\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"shared_words.approved\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isSubmittedAction\"]],[[[1,\"        \"],[10,1],[14,0,\"cAP--label--warning\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"approval.secondary-modal.body.submitted_for_review\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]],null]],[]]],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@action\"],false,[\"concat-classes\",\"if\",\"t\"]]",
    "moduleName": "shared/components/shared/post/secondary/activity/action.hbs",
    "isStrictMode": false
  });
  class ApprovedActionComponent extends _component2.default {
    get isSubmittedAction() {
      return this.args.action.content === _postActivity.PostActivityType.Submitted;
    }
    get isApprovedAction() {
      return this.args.action.content === _postActivity.PostActivityType.Approved;
    }
    get usernameInitial() {
      return (0, _string.capitalize)(this.args.action.username[0]);
    }
  }
  _exports.default = ApprovedActionComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ApprovedActionComponent);
});